import React from 'react';
import IconLink from "./IconLink";
import {Box} from "@mui/material";

function PortfolioBlock() {
   
   return (
      <Box style={{fontSize:50,marginTop:150}} display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
        Brooo i sell OG 🌿
    
      </Box>
   );
}

export default PortfolioBlock;